/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import FormFields from '../fw/FormFields.react';
import LastOrganisationId from '../app/LastOrganisationId';
import {RadioGroup} from 'formsy-react-components';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'organisationAdd.title', 'defaultMessage': 'Adding organisation'},
    billType: {id: 'organisationAdd.billType', 'defaultMessage': 'Billing type'},
    separete: {id: 'organisationAdd.separete', 'defaultMessage': 'I want to invoice separately'},
    together: {id: 'organisationAdd.together', 'defaultMessage': 'I want to invoice together'},
});

interface OrganisationAddProps {
    intl: IntlShape;
    user: User;
}

class OrganisationAdd extends React.Component<OrganisationAddProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'organisations';

    constructor() {
        super();

        this.state = {
            billType: 'separate',
        };
    }

    render() {
        let type = types[this.typeName];

		let lastOrganisationId = LastOrganisationId.get();
        let orgsToBill = this.props.user.organisations.edges.map(({node}) => node).filter((org) => org.realId === lastOrganisationId);

		if (orgsToBill.billedBy_id) {
			orgsToBill = this.props.user.organisations.edges.map(({node}) => node).filter((org) => org.realId === orgsToBill.billedBy_id);
		}

        let billingRequired = false;
        let showBillingSelection = true;
        if (this.state.billType === 'separate') {
            billingRequired = true;
        }
        if (orgsToBill.length === 0) {
            showBillingSelection = false;
            billingRequired = true;
        }

        let billingColumns = {
            'billingName': {
                required: billingRequired,
            },
            'billingEmail': {
                required: billingRequired,
            },
            'identNum': {
                required: billingRequired,
            },
            'vatId': {
            },
            'street': {},
            'city': {},
            'zip': {},
            'country': {
                required: billingRequired,
            },
            'billingCurrency': {
                required: billingRequired,
            },
            'useInkaso': {},
            'bankAccount': {},
        };

        if (!billingRequired) {
            billingColumns = {
                'billedBy': {
                    values: orgsToBill,
                    displayKey: 'name'
                }
            };
        }

        return (
            <AppPanel title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={['name', 'email', 'phoneNumber', 'www', 'billingName', 'billingEmail', 'billingCurrency', 'identNum', 'vatId', 'street', 'city', 'zip', 'country', 'billedBy', 'useInkaso', 'bankAccount']}
					defaultValue={{
						billedBy: orgsToBill,
						billedBy_id: orgsToBill.realId
					}}
                    disableAutoFields
                    fatQuery={Relay.QL `fragment on CreateOrganisationPayload {
                        edge {
                            node {
                                id,
                                realId,
                                name,
                                description,
                                street,
                                city,
                                zip,
                                email,
                                www,
                                logo,
                                billingEmail,
                                billingCurrency,
                                phoneNumber,
                                identNum,
                                vatId,
                                useInkaso,
                                bankAccount,
                                country,
                                billedBy {
                                    id,
                                },
                                billedBy_id,
                            }
                        },
                        user {
                            organisations2user(first: 10000) {
                                edges {
                                    node {
                                        id,
                                        organisation_id,
                                        role,
                                        permissions,
                                    }
                                }
                            },
                            organisations(first: 10000) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        name,
                                        description,
                                        billedBy_id
                                    }
                                }
                            }
                        }
                    }`}
					focus='name'
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createOrganisation }`}
                    urlMapping={urlMapping}
                >
                    <FormFields columns={['name']}
                                isCreate
                                metadata={type}
                    />

                    <div className="bs-callout bs-callout-success">
                        <h4><FormattedMessage defaultMessage="Contact information (optional)" id="organisation.contact" /></h4>
                        <FormFields columns={['email', 'phoneNumber']}
                                    isCreate
                                    metadata={type}
                        />
                    </div>

                    <div className="bs-callout bs-callout-default">
                    <h4><FormattedMessage defaultMessage="Billing information (required)" id="organisation.billingRequired" /></h4>
                        {showBillingSelection ? <div className="formGroup">
                            <RadioGroup
                                label={this.props.intl.formatMessage(messages.billType)}
                                name="billedSeparatedly"
                                onChange={(key, val) => {
                                    this.setState({billType: val});
                                }}
                                options={[
                                    {value: 'separate', label: this.props.intl.formatMessage(messages.separete)},
                                    {value: 'together', label: this.props.intl.formatMessage(messages.together)},
                                ]}
                                value={this.state.billType}
                            />
                        </div> : null}

                        <FormFields columns={billingColumns}
                                    isCreate
                                    metadata={type}
                        />

                        <p><FormattedMessage defaultMessage="You will be billed by invoice." id="organisation.billingNote" /></p>
                    </div>

                </Editor>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(injectIntl(OrganisationAdd), {
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                id,
                organisations(first: 500) {
                    edges {
                        node {
                            id,
                            realId,
                            name,
                            billedBy_id,
                        }
                    }
                }
            }
        `,
    },
});
